<template>
  <div v-if="isPC" class="top-wrapper">
    <span class="top-item home-icon" @click="backToHome"></span>
    <span class="top-item share-icon" @click="openShare"></span>
    <!-- <span class="top-item game-icon" @click="openGame"></span> -->
    <!-- <span class="top-item rank-icon" @click="openRank"></span> -->
    <!-- <span class="search-area">
      <input type="text" v-model.trim="searchContent">
      <span class="search-button" @click="doSearch"></span>
    </span> -->
  </div>
  <div v-else class="top-wrapper">
    <span class="top-item home-icon" @touchstart="backToHome"></span>
    <span class="top-item share-icon" @touchstart="openShare"></span>
    <!-- <span class="top-item game-icon" @touchstart="openGame"></span> -->
    <!-- <span class="top-item rank-icon" @touchstart="openRank"></span> -->
    <!-- <span class="search-area">
      <input type="text" v-model.trim="searchContent">
      <span class="search-button" @touchstart="doSearch"></span>
      <div class="int" @touchstart="inputFocus"></div>
    </span> -->
  </div>
</template>

<script>
export default {
  name: 'TopMenu',
  data() {
    return {
      searchContent: ''
    }
  },
  mounted() {
    console.log('topmenu')
    let topWarpper = document.querySelector('.top-wrapper')
    topWarpper.parentNode.parentNode.style.width = 50 + 'rem'
    topWarpper.parentNode.parentNode.style.right = 0
    topWarpper.parentNode.style.width = 50 + 'rem'
    topWarpper.parentNode.style.right = 0
  },
  methods: {
    backToHome() {
      // window.location.href = '/2022_kyzx/#/index.html'
      window.location.href = '/#/index.html'
    },
    openShare() {
      window.krpano && window.krpano.call('popup_share()')
    },
    openGame() {
      window.krpano && window.krpano.call('popup_game()')
    },
    openRank() {
      window.krpano && window.krpano.call('popup_rank()')
    },
    doSearch() {
      window.krpano && window.krpano.call('popup_search("' + this.searchContent + '")')
    },
    inputFocus() {
      setTimeout(function () {
        window.$('.top-wrapper input').focus()
      }, 500)
    }
  }
}
</script>

<style scoped>
.top-wrapper {
  position: absolute;
  top: 10px;
  right: 40px;
  padding-left: 20px;
  padding-right: 20px;
  height: 4rem;
  line-height: 4rem;
  background-color: rgba(0, 0, 0, 0.4);
}
.top-item {
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
  vertical-align: top;
  margin-top: 0.2rem;
  opacity: 0.8;
}
.top-item:hover {
  opacity: 1;
}
.home-icon {
  cursor: pointer;
  width: 4rem;
  height: 3rem;
  line-height: 3rem;
  color: #ffffff;
  font-size: 16px;
  background-image: url("../../assets/krpano_icon/home_icon.png");
  background-size: 100% 100%;
}
.share-icon {
  width: 4rem;
  height: 3rem;
  background-image: url("../../assets/krpano_icon/share.png");
  background-size: 100% 100%;
}
.game-icon {
  width: 3rem;
  height: 3rem;
  background-image: url("../../assets/krpano_icon/game.png");
  background-size: 100% 100%;
}
.rank-icon {
  width: 5rem;
  height: 3rem;
  background-image: url("../../assets/krpano_icon/rank.png");
  background-size: 100% 100%;
}
.search-area {
  position: relative;
  display: inline-block;
  width: 18rem;
  height: 4rem;
  line-height: 4rem;
}
.search-area input {
  padding-left: 4rem;
  padding-right: 1rem;
  width: 100%;
  height: 3rem;
  line-height: 3rem;
  background: none;
  outline: none;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 1.5rem;
  color: #ffffff;
  font-size: 12px;
}
.search-area input:focus {
  outline: none;
}
.search-area .int {
  position: absolute;
  top: 0;
  left: 3.8rem;
  right: 0;
  bottom: 0;
  /*background-color: red;*/
  background-color: rgba(0, 0, 0, 0.02);
}
.search-button {
  position: absolute;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  opacity: 0.8;
  left: 0.8rem;
  top: 1.25rem;
  background-image: url("../../assets/krpano_icon/search.svg");
  background-size: 100% 100%;
  cursor: pointer;
}
</style>
